import React from "react";

interface AutoDisablingButtonProps {
    disabled?: boolean;
    onClick?: () => void;
    children: React.ReactNode;
    type?: "button" | "submit" | "reset";
    className: string
}

export const AutoDisablingButton: React.FC<AutoDisablingButtonProps> = ({disabled, onClick, children,type, className}) => {
    return (
        <button onClick={onClick} type={type} className={className} disabled={disabled}>
            {children}
        </button>
    );
};